module.exports = __webpack_public_path__ + "static/media/bg-1.4504ad46.png";